export const RETIREMENT_CALCULATOR_NAMESPACE = 'retirement-calculator';

export const CALC_TEST_ID = 'RetirementCalculator';
export const CALC_FORM_TEST_ID = `${CALC_TEST_ID}Form`;
export const CALC_RESULT_TEST_ID = `${CALC_TEST_ID}Result`;
export const CALC_SAVINGS_TEST_ID = `${CALC_TEST_ID}Savings`;
export const CALC_LIMITS_TEST_ID = `${CALC_TEST_ID}Limits`;
export const CALC_OUTCOME_TEST_ID = `${CALC_TEST_ID}Outcome`;

export const NO_VALUE_PLACEHOLDER = '⎯ ⎯ ⎯';

export const MIN_MONTHLY_GROSS_SALARY = 1;

export const MIN_AGE = 18;
// TODO: uzupełnić maksymalny wiek - być może będzie to ?70
export const MAX_AGE = 99;

export const BIRTH_YEAR_LENGTH = 4;

export const MONTHS_IN_YEAR = 12;

export enum EmploymentType {
  EMPLOYMENT_CONTRACT = 'employment-contract',
  BUSINESS = 'business',
}

export enum Gender {
  FEMALE = 'female',
  MALE = 'male',
}

export enum RetirementCalculatorField {
  MONTHLY_GROSS_SALARY = 'monthlyGrossSalary',
  EMPLOYMENT_TYPE = 'employmentType',
  BIRTH_YEAR = 'birthYear',
  GENDER = 'gender',
}

export const RETIREMENT_CALCULATOR_FIELDS_ORDER = [
  RetirementCalculatorField.MONTHLY_GROSS_SALARY,
  RetirementCalculatorField.EMPLOYMENT_TYPE,
  RetirementCalculatorField.BIRTH_YEAR,
  RetirementCalculatorField.GENDER,
] as const;

export const RETIREMENT_AGE: Record<Gender, number> = {
  [Gender.FEMALE]: 60,
  [Gender.MALE]: 65,
};

export const DEFAULT_PAYOUT_YEARS = 10;

// TODO: uzupełnić średnią roczną stopę zwrotu
export const DEFAULT_AVERAGE_RETURN_RATE = 0;

export enum RetirementCalculatorSettingsField {
  AVERAGE_RETURN_RATE = 'averageReturnRate',
  RETIREMENT_AGE = 'retirementAge',
  PAYOUT_YEARS = 'payoutYears',
}

export const MIN_AVERAGE_RETURN_RATE_PERCENT = 0;
export const MAX_AVERAGE_RETURN_RATE_PERCENT = 20;
export const AVERAGE_RETURN_RATE_DECIMAL_SCALE = 2;

export const MIN_PAYOUT_YEARS = 1;
export const MAX_PAYOUT_YEARS = 40;

export enum RetirementCalculatorStep {
  BASIC_DATA = 1,
  SAVINGS = 2,
  OUTCOME = 3,
}

export const RETIREMENT_CALCULATOR_STEPS_COUNT = 3;

export enum SavingsProduct {
  PPK = 'ppk',
  PPE = 'ppe',
  IKE = 'ike',
  IKZE = 'ikze',
  OTHER = 'other',
}

export const SAVINGS_PRODUCTS_ORDER = [
  SavingsProduct.PPK,
  SavingsProduct.PPE,
  SavingsProduct.IKE,
  SavingsProduct.IKZE,
  SavingsProduct.OTHER,
] as const;

export const SAVINGS_PRODUCT_LABELS: Record<SavingsProduct, string> = {
  [SavingsProduct.PPK]: 'PPK',
  [SavingsProduct.PPE]: 'PPE',
  [SavingsProduct.IKE]: 'IKE',
  [SavingsProduct.IKZE]: 'IKZE',
  [SavingsProduct.OTHER]: 'Inne Oszczędności',
};

export enum SavingsField {
  ACCUMULATED = 'accumulated',
  MONTHLY_CONTRIBUTION = 'monthlyContribution',
}

export const SAVINGS_PRODUCT_RULES: Record<
  SavingsProduct,
  { hasYearlyLimit: boolean; earnsReturn: boolean; payoutTaxRate: number }
> = {
  [SavingsProduct.PPK]: { hasYearlyLimit: false, earnsReturn: true, payoutTaxRate: 0 },
  [SavingsProduct.PPE]: { hasYearlyLimit: true, earnsReturn: true, payoutTaxRate: 0 },
  [SavingsProduct.IKE]: { hasYearlyLimit: true, earnsReturn: true, payoutTaxRate: 0 },
  [SavingsProduct.IKZE]: { hasYearlyLimit: true, earnsReturn: true, payoutTaxRate: 0.1 },
  [SavingsProduct.OTHER]: { hasYearlyLimit: false, earnsReturn: false, payoutTaxRate: 0 },
};

export const SAVINGS_PRODUCT_CHART_COLORS: Record<
  SavingsProduct,
  'chartColor1' | 'chartColor6' | 'chartColor7' | 'chartColor10' | 'chartColor19'
> = {
  [SavingsProduct.PPK]: 'chartColor6',
  [SavingsProduct.PPE]: 'chartColor1',
  [SavingsProduct.IKE]: 'chartColor7',
  [SavingsProduct.IKZE]: 'chartColor10',
  [SavingsProduct.OTHER]: 'chartColor19',
};

export const ZUS_CHART_COLOR = 'chartColor18';
export const CHART_MIN_SCALE_MAX = 5000;
export const CHART_STEPS = 5;

export const PROMOTED_PRODUCT_SALARY_THRESHOLD = 12000;

export const MIN_MONTHLY_INVESTMENT = 50;
export const DEFAULT_MONTHLY_INVESTMENT = 200;
export const FALLBACK_MAX_MONTHLY_INVESTMENT = 2000;

export const OUTCOME_ASSUMPTION_KEYS = ['return-rate', 'today-money', 'payout-period'] as const;
